class CustomCartNotes extends HTMLElement {
  constructor() {
    super();
    this.noteText = this.querySelector('#CartNoteDrawer');
    this.senBtn = this.querySelector('.js-drawer-close-cart-note');
    this.senBtn.addEventListener('click', this.onSendNote);
  }

  onSendNote = async () => {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: this.noteText.value,
      }),
    });
  };
}

const PRODUCT_NOTE_ATTRIBUTE_KEY = 'Note';
class CustomGiftBox extends HTMLElement {
  constructor() {
    super();
    this.giftBoxItems = this.querySelectorAll('gift-box-item-collapsible');
    this.productHandle = this.getAttribute('data-product-handle');
    this.images = this.querySelectorAll('.drawer_gift-box-image');
    this.parentId = this.getAttribute('data-parent-id');
    this.parentContainer =
      this.parentId !== null && this.parentId.length > 0
        ? document.querySelector(`#${this.parentId}`)
        : null;
    this.context = this.getAttribute('data-context') || 'drawer';
    this.productData = null;
    this.defaultVariant = null;
    this.variantIds = [];
    this.init();
  }

  init = async () => {
    if (!this.giftBoxItems.length) {
      return;
    }
    this.productData = await this.getProductData();
    this.defaultVariant = this.productData?.variants?.at(0)?.id;
    this.variantIds = this.productData?.variants?.map((variant) => variant.id);
    this.giftBoxItems.forEach((giftBoxItem) => {
      giftBoxItem
        .querySelector('.drawer_gift-box-note-btn-type')
        .addEventListener('click', (e) =>
          this.openGiftBoxContent({ e, targetGiftBoxItem: giftBoxItem }),
        );
      giftBoxItem.context = this.context;
    });
    this.initCartObserver();
    this.checkCart();
  };

  openGiftBoxContent = ({ e, targetGiftBoxItem }) => {
    let targetPrimaryOption = null;
    this.giftBoxItems.forEach((giftBoxItem) => {
      const giftBoxButton = giftBoxItem.querySelector(
        '.drawer_gift-box-note-btn-type',
      );
      if (
        targetGiftBoxItem === giftBoxItem &&
        !giftBoxItem.classList.contains('drawer_gift-box-collapsible-open')
      ) {
        giftBoxItem.classList.add('drawer_gift-box-collapsible-open');
        giftBoxButton.classList.add('btn--outline');
        targetPrimaryOption = giftBoxItem.getAttribute(
          'data-primary-option-value',
        );
      } else {
        giftBoxItem.classList.remove('drawer_gift-box-collapsible-open');
        giftBoxButton.classList.remove('btn--outline');
      }
    });

    const targetFeaturedImage =
      targetPrimaryOption !== null
        ? this.productData.variants.find((variant) =>
            variant.options.includes(targetPrimaryOption),
          )?.featured_image?.id
        : 'primary';

    this.images.forEach((image) => {
      if (
        image.classList.contains(`drawer_gift-box-image-${targetFeaturedImage}`)
      ) {
        image.classList.remove('hide');
      } else {
        image.classList.add('hide');
      }
    });
  };

  checkCart = async () => {
    const items = await this.getPreviousItems();
    const notAllowed = [];
    const allowed = [];
    items?.forEach((item) => {
      if (
        !(
          this.defaultVariant === item.variant_id ||
          (this.variantIds.includes(item.variant_id) &&
            item.properties[PRODUCT_NOTE_ATTRIBUTE_KEY])
        ) ||
        allowed.length > 0
      ) {
        notAllowed.push(item);
      } else {
        allowed.push(item);
      }
    });
    const remove = await this.onUpdateFromCart({ items: notAllowed });
    if (allowed.length) {
      if (this.context !== 'drawer' && this.parentContainer) {
        this.parentContainer.classList.add('hide');
        this.parentContainer
          .querySelector('.collapsible-trigger')
          .classList.remove('is-open');
        this.parentContainer
          .querySelector('.collapsible-content')
          .classList.remove('is-open');
        this.parentContainer.querySelector(
          '.collapsible-content',
        ).style.height = '0px';
      }
      const currentItem = allowed[0];
      const currentNote =
        currentItem.properties[PRODUCT_NOTE_ATTRIBUTE_KEY] || '';
      if (currentItem.quantity > 1) {
        const update = await this.onUpdateFromCart({
          items: [currentItem],
          unique: true,
        });
        if (update) {
          document.dispatchEvent(new Event('cart:build'));
        }
      }
      this.giftBoxItems.forEach((giftBoxItem) => {
        const giftBoxItemPrimaryOption = giftBoxItem.getAttribute(
          'data-primary-option-value',
        );
        if (currentItem.variant_options.includes(giftBoxItemPrimaryOption)) {
          giftBoxItem.lineItem = currentItem;
          giftBoxItem.classList.add('drawer_gift-box-collapsible-open');
          giftBoxItem
            .querySelector('.drawer_gift-box-note-btn-type')
            .classList.add('btn--outline');
        } else {
          giftBoxItem.lineItem = null;
          giftBoxItem.classList.remove('drawer_gift-box-collapsible-open');
          giftBoxItem
            .querySelector('.drawer_gift-box-note-btn-type')
            .classList.remove('btn--outline');
        }
        giftBoxItem.note = currentNote;
      });
    } else {
      if (this.context !== 'drawer' && this.parentContainer) {
        this.parentContainer.classList.remove('hide');
      }
      this.giftBoxItems.forEach((giftBoxItem) => {
        giftBoxItem.lineItem = null;
        giftBoxItem.classList.remove('drawer_gift-box-collapsible-open');
        giftBoxItem
          .querySelector('.drawer_gift-box-note-btn-type')
          .classList.remove('btn--outline');
        giftBoxItem.note = '';
      });
    }
    if (remove) {
      document.dispatchEvent(new Event('cart:build'));
    }
  };

  getProductData = async () => {
    if (!this.productHandle) {
      return null;
    }

    try {
      return await fetch(`/products/${this.productHandle}.js`).then((res) =>
        res.json(),
      );
    } catch (e) {
      console.error(e);

      return null;
    }
  };

  getPreviousItems = async (cartData = null) => {
    const cart = cartData || (await this.getCart());
    const itemsOnCart = cart.items.filter(
      (item) => item.handle === this.productHandle,
    );

    return itemsOnCart;
  };

  onUpdateFromCart = async ({ items, unique = false }) => {
    if (!items.length) {
      return null;
    }
    const updates = {};
    items.forEach((item) => {
      updates[item.key] = unique ? 1 : 0;
    });
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        },
      ).then((res) => res.json());
      return !response.message;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  getCart = async () => {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (!cart) {
        return null;
      }

      return cart;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  initCartObserver = () => {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((rawEntry) => {
        const entry = rawEntry.toJSON();
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
          entry.initiatorType,
        );
        const regex = /\/cart(\/(?!\.js\b)[^ ]*|$)/;
        const isCartChangeRequest = regex.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.checkCart();
        }
      });
    });

    cartObserver.observe({ entryTypes: ['resource'] });
  };
}

class CustomGiftBoxItem extends HTMLElement {
  constructor() {
    super();
    this.primaryOptionValue = this.getAttribute('data-primary-option-value');
    this.productHandle = this.getAttribute('data-product-handle');
    this.checkboxList = this.querySelectorAll(
      '.drawer_gift-box-collapsible-cards-type-input',
    );
    this.textarea = this.querySelector('.drawer_gift-box-textarea');
    this.addToCartBtn = this.querySelector('.drawer_gift-box-note-btn');
    this.textarea?.addEventListener('keyup', this.updateTextareaAndButton);
    this.addToCartBtn?.addEventListener('click', this.onAddToCart);
    this.addToCartBtnTexts = {
      primary: this.addToCartBtn.getAttribute('data-primary-text'),
      secondary: this.addToCartBtn.getAttribute('data-secondary-text'),
    };
    this.checkboxList.forEach((checkbox) =>
      checkbox.addEventListener('click', this.onCheckBoxClick),
    );
    this.productData = null;
    this.targetVariant = null;
    this._lineItem = null;
    this._context = 'drawer';
    this.init();
  }

  set lineItem(value) {
    this._lineItem = value;
    if (value === null) {
      this.checkboxList.forEach((item) => {
        item.checked = false;
      });
      if (this.textarea) {
        this.textarea.value = '';
      }
    } else {
      this.targetVariant = this.productData?.variants?.find(
        (variant) => variant.id === value.variant_id,
      );
      this.checkboxList.forEach((item) => {
        item.checked = this.targetVariant?.options?.includes(item.value);
      });
      if (this.textarea) {
        this.textarea.value = value.properties[PRODUCT_NOTE_ATTRIBUTE_KEY];
      }
    }
    this.updateTextareaAndButton();
  }

  set note(value) {
    if (this.textarea) {
      this.textarea.value = value || '';
    }
    this.updateTextareaAndButton();
  }

  set context(value) {
    this._context = value;
  }

  init = async () => {
    this.productData = await this.getProductData();
    this.targetVariant = this.productData.variants.find((variant) =>
      variant.options.includes(this.primaryOptionValue),
    );
    this.updateTextareaAndButton();
  };

  onCheckBoxClick = (e) => {
    const el = e.currentTarget;
    this.checkboxList.forEach((item) => {
      if (item !== el) {
        item.checked = false;
      }
    });
    this.updateTextareaAndButton();
  };

  updateTextareaAndButton = () => {
    const targetCheckbox =
      [...this.checkboxList].find((item) => item.checked) || null;
    const allowByCheckBox = this.checkboxList.length
      ? targetCheckbox !== null
      : true;
    const allowBtn =
      this.textarea !== null
        ? this.textarea.value.length > 0 && allowByCheckBox
        : true;
    this.addToCartBtn.disabled = !allowBtn;

    this.targetVariant =
      this.checkboxList.length && targetCheckbox
        ? this.productData?.variants?.find(
            (variant) =>
              variant.options.includes(this.primaryOptionValue) &&
              variant.options.includes(targetCheckbox.value),
          ) || null
        : this.checkboxList.length === 0
          ? this.productData?.variants?.find((variant) =>
              variant.options.includes(this.primaryOptionValue),
            ) || null
          : null;

    const buttonSaveSpan = this.addToCartBtn.querySelector('span');

    if (this._lineItem !== null) {
      buttonSaveSpan.innerHTML = this.addToCartBtnTexts.secondary;
    } else {
      buttonSaveSpan.innerHTML = this.addToCartBtnTexts.primary.replace(
        '{box.price}',
        !this.targetVariant
          ? ''
          : this.convertToMoney({
              amount: this.targetVariant.price,
            }),
      );
    }
  };

  onAddToCart = async () => {
    if (!this.targetVariant && !this._lineItem) {
      return;
    }

    this.addToCartBtn.classList.add('btn--loading');

    let response = false;

    if (
      this._lineItem !== null &&
      this.targetVariant.id === this._lineItem.variant_id
    ) {
      response = await this.updateItemFromCart({
        item: this._lineItem,
        quantity: 1,
        properties:
          this.textarea !== null
            ? {
                [PRODUCT_NOTE_ATTRIBUTE_KEY]: this.textarea.value,
              }
            : undefined,
      });
    } else if (this.targetVariant !== null) {
      await this.removePreviousItems();
      response = await this.addToCart({
        quantity: 1,
        variantId: this.targetVariant.id,
        properties:
          this.textarea !== null
            ? {
                [PRODUCT_NOTE_ATTRIBUTE_KEY]: this.textarea.value,
              }
            : undefined,
      });
    }

    if (response) {
      document.dispatchEvent(new Event('cart:build'));
      if (this._context !== 'drawer') {
        document.dispatchEvent(new Event('cart:open'));
      }
    }

    this.addToCartBtn.classList.remove('btn--loading');
  };

  addToCart = async ({ quantity, variantId, properties = undefined }) => {
    if (!quantity || !variantId) {
      return false;
    }

    try {
      const formData = { items: [] };

      formData.items.push({
        id: variantId,
        quantity: quantity,
        properties: properties,
      });

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }).then((res) => res.json());

      return addResponse && addResponse?.items?.length > 0;
    } catch (e) {
      console.error(e);

      return false;
    }
  };

  updateFromCart = async ({ items, unique = false }) => {
    if (!items.length) {
      return null;
    }
    const updates = {};
    items.forEach((item) => {
      updates[item.key] = unique ? 1 : 0;
    });
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        },
      ).then((res) => res.json());
      return !response.message;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  updateItemFromCart = async ({ item, quantity, properties = undefined }) => {
    if (!item) {
      return null;
    }
    const updates = {
      id: item.key,
      quantity,
      properties,
    };
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/change.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        },
      ).then((res) => res.json());
      return !response.message;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  getCart = async () => {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (!cart) {
        return null;
      }

      return cart;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  getProductData = async () => {
    if (!this.productHandle) {
      return null;
    }

    try {
      return await fetch(`/products/${this.productHandle}.js`).then((res) =>
        res.json(),
      );
    } catch (e) {
      console.error(e);

      return null;
    }
  };

  getPreviousItems = async () => {
    const cart = await this.getCart();
    const itemsOnCart = cart.items.filter(
      (item) => item.handle === this.productHandle,
    );

    return itemsOnCart;
  };

  removePreviousItems = async () => {
    const items = await this.getPreviousItems();
    await this.updateFromCart({ items });
  };

  convertToMoney = ({ amount }) => {
    const value = amount / 100;
    const locale = `${window?.Shopify?.locale || 'en'}-${window?.Shopify?.country || 'US'}`;
    const currency = window?.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
    }).format(value);
  };
}

class CustomRelatedProduct extends HTMLElement {
  constructor() {
    super();
    this.btnCheckBox = this.querySelector(
      '.cart__item-related-product-checkbox',
    );
    this.productId = Number(this.getAttribute('data-product-id')) || null;
    this.variantId = Number(this.getAttribute('data-variant-id')) || null;
    this.btnCheckBox?.addEventListener('click', this.onClick);
  }

  connectedCallback() {
    document.addEventListener('cart-custom-component:check-cart', (e) => {
      const {
        detail: { cart },
      } = e;
      this.checkCart({ cart });
    });
  }

  checkCart = ({ cart }) => {
    if (!cart) {
      return;
    }

    const isItemInCart = cart.items.some(
      (item) =>
        item.variant_id === this.variantId ||
        item.product_id === this.productId,
    );

    if (isItemInCart) {
      this.btnCheckBox.classList.add(
        'cart__item-related-product-checkbox-active',
      );
      this.classList.add('cart__item-related-product-in-cart');
    } else {
      this.btnCheckBox.classList.remove(
        'cart__item-related-product-checkbox-active',
      );
      this.classList.remove('cart__item-related-product-in-cart');
    }
  };

  getCart = async () => {
    try {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (!cart) {
        return null;
      }

      return cart;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  onClick = async (e) => {
    const el = e.currentTarget;
    if (!el) {
      return;
    }
    el.classList.toggle('cart__item-related-product-checkbox-active');
    const response = await this.onAddToCart({
      variantId: this.variantId,
      quantity: 1,
    });
    if (response) {
      document.dispatchEvent(new Event('cart:build'));
    }
  };

  onAddToCart = async ({ quantity, variantId, properties = undefined }) => {
    if (!quantity || !variantId) {
      return false;
    }

    try {
      const formData = { items: [] };

      formData.items.push({
        id: variantId,
        quantity: quantity,
        properties: properties,
      });

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }).then((res) => res.json());

      return addResponse && addResponse?.items?.length > 0;
    } catch (e) {
      console.error(e);

      return false;
    }
  };

  onUpdateFromCart = async ({ items, unique = false }) => {
    if (!items.length) {
      return null;
    }
    const updates = {};
    items.forEach((item) => {
      updates[item.key] = unique ? 1 : 0;
    });
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        },
      ).then((res) => res.json());
      return !response.message;
    } catch (e) {
      console.error(e);
      return null;
    }
  };
}

if (!customElements.get('custom-cart-notes')) {
  customElements.define('custom-cart-notes', CustomCartNotes);
}

if (!customElements.get('gift-box')) {
  customElements.define('gift-box', CustomGiftBox);
}

if (!customElements.get('gift-box-item-collapsible')) {
  customElements.define('gift-box-item-collapsible', CustomGiftBoxItem);
}

if (!customElements.get('custom-related-product')) {
  customElements.define('custom-related-product', CustomRelatedProduct);
  document.addEventListener('DOMContentLoaded', () => {
    const getCart = async () => {
      try {
        const cart = await fetch('/cart.js').then((res) => res.json());

        if (!cart) {
          return null;
        }

        return cart;
      } catch (e) {
        console.error(e);
        return null;
      }
    };

    const onCheckCallback = async () => {
      const cart = await getCart();
      document.dispatchEvent(
        new CustomEvent('cart-custom-component:check-cart', {
          detail: {
            cart: cart,
          },
        }),
      );
    };

    const initCartObserver = () => {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((rawEntry) => {
          const entry = rawEntry.toJSON();
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
            entry.initiatorType,
          );
          const regex = /\/cart(\/(?!\.js\b)[^ ]*|$)/;
          const isCartChangeRequest = regex.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            onCheckCallback();
          }
        });
      });

      cartObserver.observe({ entryTypes: ['resource'] });
    };

    onCheckCallback();
    initCartObserver();
  });
}
